export const getArrayOptionsFromObject = (dictionaryObject) => {
    const { values, featured } = dictionaryObject;

    return Object.keys(values).map((key) => ({
        label: values[key],
        value: key,
        featuredPosition: featured.indexOf(key)
    }));
};
